import type { TOC } from '@ember/component/template-only';
import { PrismLoadingBar } from '@mylighthouse/prism-ember';
import { or } from 'ember-truth-helpers';
import SettingsAutopilotAutopilot from 'lumen/components/settings/autopilot/autopilot';
import type HotelSettingsAutopilotController from 'lumen/controllers/hotel/settings/autopilot';

interface HotelSettingsAutopilotSignature {
  Args: {
    controller: HotelSettingsAutopilotController;
    model: unknown;
  };
}

<template>
  {{#if
    (or
      @controller.model.saveAndUpdateAutopilotSettings.isRunning
      @controller.model.pricingAssistantAutopilotScheduleOptionsTask.isRunning
    )
  }}
    <PrismLoadingBar />
  {{/if}}

  <SettingsAutopilotAutopilot
    @hasUserChangedAutopilotSettingsValue={{@controller.hasUserChangedAutopilotSettingsValue}}
    @model={{@controller.model}}
    @updateHasUserChangedAutopilotSettingsValue={{@controller.updateHasUserChangedAutopilotSettingsValue}}
  />
</template> satisfies TOC<HotelSettingsAutopilotSignature>;
